import { connect } from "react-redux";
import { EquationList } from "./equation-list";
import {
    getValidEquationResponse,
    getValidCropList,
    getHasUnlinkedCrop,
    getHasUnlinkedProduct,
} from "./data/selectors";
import {
    validateEquationToggle,
    testEquationSuccess,
    validateCropListToggle,
    unlinkedCropsToggle,
    unlinkedProductsToggle,
} from "./data/actions";

const mapStateToProps = (state) => ({
    validCropList: getValidCropList(state),
    hasUnlinkedCrop: getHasUnlinkedCrop(state),
    hasUnlinkedProduct: getHasUnlinkedProduct(state),
    validEquationResponse: getValidEquationResponse(state),
});

const mapDispatchToProps = (dispatch) => ({
    validateCropListToggle: (payload) => dispatch(validateCropListToggle(payload)),
    unlinkedCropsToggle: (payload) => dispatch(unlinkedCropsToggle(payload)),
    unlinkedProductsToggle: (payload) => dispatch(unlinkedProductsToggle(payload)),
    validateEquationToggle: (payload) => dispatch(validateEquationToggle(payload)),
    testEquationSuccess: (payload) => dispatch(testEquationSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EquationList);
